import {
  Button,
  Column,
  Form,
  Image,
  InputWithLoader,
  Row,
  CSSSection as Section,
} from "@oxygen/core";
import getThemeClasses from "@oxygen/theme";
import { CSSFlex } from "GlobalComponent/CSSCore";
import { EMAIL_PLACE_HOLDER } from "GlobalConstant/";
import {
  COMMON_BORDER_CLASS,
  ptClassName,
  pbClassName,
  plClassName,
  prClassName,
} from "GlobalConstant/ClassNames";
import { MAIL_ICON } from "GlobalConstant/Icons";
import { platform } from "GlobalEnum/Platform";
import { makeCancelable } from "GlobalUtils/CancelablePromise";
import { validateEmail } from "GlobalUtils/Validate";
import PropTypes from "prop-types";
import React, { memo, useEffect, useState } from "react";
import { subscribeEmail } from "../api";

const containerClasses = getThemeClasses(`
  flex-direction-column;
  bg-whiteSmokeLight;
  pl-3 md:pl-5;
  pr-3 md:pr-5;
  pt-4 md:pt-5;
`);

const infoContainerClasses = getThemeClasses(`
  pl-1;
  pb-4;
`);

const imageWrapperClasses = getThemeClasses(`
  width-12;
  height-12;
`);

const textWrapperClasses = getThemeClasses(`
  ml-2;
`);

const textClasses = getThemeClasses(`
  font-size-8 md:font-size-9;
  font-weight-bold;
  color-charcoal;
`);

function getSignupTextClasses(isMobile) {
  return getThemeClasses(`
  font-size-7.5;
  mt-2;
 ${isMobile ? "color-dimGray" : ""}
`);
}
const bottomMarginClasses = getThemeClasses(`
  mb-0 md:mb-1;
`);
const propTypes = {
  modelId: PropTypes.number, // modelId for model page
  isWrappedInPopup: PropTypes.bool, // flag to determine whether parent is a popup.
};

const defaultProps = {
  isWrappedInPopup: false,
  platForm: platform.MOBILE,
};

function Description({ isMobile }) {
  return isMobile ? (
    <>
      <div className={textClasses}>Catch all the upcoming action,</div>
      <div className={textClasses}>right in your inbox!</div>
    </>
  ) : (
    <div className={textClasses}>
      Catch all the upcoming action, right in your inbox!
    </div>
  );
}
let apiPromise = null;
export const KeepMeInformed = memo(function KeepMeInformed(props) {
  const { modelId, isWrappedInPopup, platForm, onSubmit } = props;
  const [valiadtionMessage, setValidationMessage] = useState("");
  const [email, setEmail] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  useEffect(() => {
    return () => {
      apiPromise && apiPromise.cancel();
    };
  }, []);

  const isMobile = platForm.id === platform.MOBILE.id;
  const handleApiResponse = response => {
    setIsFetching(false);
    onSubmit && onSubmit(response); // close the popup if it is wrapped in a popup
  };

  const handleSubscribeButtonClick = event => {
    event.preventDefault();
    const validationResponse = validateEmail(email);
    if (validationResponse && validationResponse.isValid) {
      setIsFetching(true);
      apiPromise && apiPromise.cancel();
      apiPromise = makeCancelable(subscribeEmail(email, modelId));
      apiPromise.promise.then(handleApiResponse).catch(error => {
        setIsFetching(false);
        console.log("Error in subscribe email ", error);
      });
    } else {
      setValidationMessage(validationResponse.errMessage);
    }
  };
  const handleOnChange = event => {
    event.preventDefault();
    const emailId = event.target.value;
    setEmail(emailId);
    setValidationMessage("");
  };
  let sectionProps = {};
  let sectionBodyProps = {};
  if (isWrappedInPopup) {
    sectionProps = {
      ptClassName: ptClassName,
      pbClassName: pbClassName,
    };
    sectionBodyProps = {
      ptClassName: ptClassName,
      pbClassName: pbClassName,
      plClassName: plClassName,
      prClassName: prClassName,
    };
  }
  return (
    <Section {...sectionProps}>
      <Section.Meta type="body" {...sectionBodyProps}>
        <CSSFlex
          className={`${containerClasses} ${
            isWrappedInPopup ? bottomMarginClasses : COMMON_BORDER_CLASS
          }`}
        >
          <CSSFlex className={infoContainerClasses}>
            <div className={imageWrapperClasses}>
              <Image
                src={MAIL_ICON}
                description={`Mail Image`}
                aspectRatio="1:1"
              />
            </div>
            <div className={textWrapperClasses}>
              <Description isMobile={isMobile} />
              <div className={getSignupTextClasses(isMobile)}>
                Sign up for upcoming car alerts
              </div>
            </div>
          </CSSFlex>
          <Row as={Form}>
            <Column
              span={8}
              as={Form.Item}
              validateStatus={valiadtionMessage.length ? "error" : ""}
              helperText={valiadtionMessage}
            >
              <InputWithLoader
                id="email"
                type="email"
                placeholder={EMAIL_PLACE_HOLDER}
                value={email}
                onChange={handleOnChange}
                isLoading={isFetching}
                data-testing-id="email"
              />
            </Column>
            <Column span={4} as={Form.Item}>
              <Button
                htmlType="submit"
                block
                onClick={handleSubscribeButtonClick}
                size="md"
                data-testing-id="subscribe-now"
              >
                Subscribe Now
              </Button>
            </Column>
          </Row>
        </CSSFlex>
      </Section.Meta>
    </Section>
  );
});

KeepMeInformed.displayName = "KeepMeInformed";
KeepMeInformed.propTypes = propTypes;
KeepMeInformed.defaultProps = defaultProps;
